import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getSchedulesRegimeUsage = api(async function getSchedulesRegimeUsage(ids) {
    return !ids?.length
        ? []
        : query(
              gql`
                  query GetSchedulesRegimeUsage($ids: [String!]!) {
                      getSchedulesRegimeUsage(ids: $ids)
                  }
              `,
              { ids },
              { returns: "getSchedulesRegimeUsage" }
          )
})
